import React, { useEffect } from "react";
import { CMPComposition } from "./CMPComposition";
import { Label } from "@logora/parliament.ui.label";
import styles from "./CommissionMixteParitaire.module.scss";

export const CommissionMixteParitaire = ({ acteLegislatif, document }) => {
    const date = new Date(
        acteLegislatif.dateActe,
    ).toLocaleDateString("fr-FR", {
        year: "numeric",
        month: "long",
        day: "numeric",
    })

    return (
        <>
            {acteLegislatif.codeActe === "CMP-DEC" && (
                <div>
                    {acteLegislatif.libelleStatutConclusion === "Accord" && (
                        <Label
                            colorType={"neutral"}
                            variantsObject={{
                                info: "neutral",
                            }}
                            className={styles.label}
                            text={
                                `La commission mixte paritaire est parvenue à proposer un texte le ${date}`
                            }
                        />
                    )}
                    {acteLegislatif.libelleStatutConclusion === "Désaccord" && (
                        <Label
                            colorType={"neutral"}
                            variantsObject={{
                                info: "neutral",
                            }}
                            className={styles.label}
                            text={
                                "La commission mixte paritaire a constaté ne pouvoir parvenir à élaborer un texte commun"
                            }
                        />
                    )}
                </div>
            )}
            {acteLegislatif.codeActe === "CMP-SAISIE" && (
                <CMPComposition acteLegislatif={acteLegislatif} date={date} />
            )}
            
            
        </>
    );
};
